import React from 'react'
import { Row, Col } from 'antd'

export function PaneFooter({ backButton, nextButton, leftText, className }) {
  return (
    <div className={'pane-footer ' + className}>
      <Row>
        <Col style={{ display: 'flex', justifyContent: 'flex-start' }} span={12}>
          {backButton ? backButton() : leftText}
        </Col>
        <Col style={{ display: 'flex', justifyContent: 'flex-end' }} span={12}>
          {nextButton && nextButton()}
        </Col>
      </Row>
    </div>
  )
}
